import { SR_API_ACTION_SEND_TOUR_REQUEST_EMAIL } from 'api/actionTypes';

export default async function sendTourRequestEmail({ state, apiClient }, { listingId }) {
  return apiClient.postWithState({
    state: state,
    action: SR_API_ACTION_SEND_TOUR_REQUEST_EMAIL,
    payload: {
      listingId: listingId,
    },
    onSuccess: (buyersSideTourRequest) => {
      state.set(['buyersSideTourRequests', 'byListingAndUserId'], {
        [`${buyersSideTourRequest.listingId}-${buyersSideTourRequest.userId}`]: buyersSideTourRequest,
      });
    },
  });
}
